/* @flow */
import * as React from 'react';

import AdminUpgradeInformationalPage from 'admin/components/AdminUpgradeInformationalPage.jsx';
import AdminUpgradeCompleteButton from 'admin/components/AdminUpgradeCompleteButton.jsx';

export default class AdminUpgradeHelpConfirmationPage extends React.Component<{}> {
  render() {
    return (
      <AdminUpgradeInformationalPage
        title="Thanks for your interest in upgrading to a Remind Plan!"
        subtext="A member of our team will review your information and contact you soon to follow up—we’re looking forward to it!"
        action={<AdminUpgradeCompleteButton />}
      />
    );
  }
}
